import _Promise from 'babel-runtime/core-js/promise';
import _Object$keys from 'babel-runtime/core-js/object/keys';
import _Object$assign from 'babel-runtime/core-js/object/assign';
import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import _Object$entries from 'babel-runtime/core-js/object/entries';
import _newArrowCheck from 'babel-runtime/helpers/newArrowCheck';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _extends from 'babel-runtime/helpers/extends';
import { curry } from 'flow-static-land/lib/Fun';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import { map } from '@jumpn/utils-composite';

var _this$1 = undefined;

var getBuilder = function (values) {
  _newArrowCheck(this, _this$1);

  return function (object, key, index) {
    _newArrowCheck(this, _this$1);

    return _extends({}, object, _defineProperty({}, key, values[index]));
  }.bind(this);
}.bind(undefined);

// TODO: move to @jumpn/utils-object once we create this one
var objectBuild = function (keys, values) {
  _newArrowCheck(this, _this$1);

  return keys.reduce(getBuilder(values), {});
}.bind(undefined);

var objectBuild$1 = curry(objectBuild);

var _this = undefined;

/**
 * Returns a promise that will be resolved with an object the results of all the
 * given promises or it will reject with an Error that will have an additional
 * property "from" with the name of the promise that caused the rejection. 
 */
var allByName = function (promisesByName) {
  _newArrowCheck(this, _this);

  // we need to do this since Object.entries returns Array<[string, mixed]>
  var promiseEntries = _Object$entries(promisesByName);

  var promises = promiseEntries.map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        promise = _ref2[1];

    _newArrowCheck(this, _this);

    return promise.catch(function (error) {
      _newArrowCheck(this, _this);

      return _Object$assign(error, { from: name });
    }.bind(this));
  }.bind(this));

  var promiseNames = _Object$keys(promisesByName);

  return _Promise.all(promises).then(objectBuild$1(promiseNames));
}.bind(undefined);

var _this$2 = undefined;

var returnTrue = function () {
  _newArrowCheck(this, _this$2);

  return true;
}.bind(undefined);

var returnFalse = function () {
  _newArrowCheck(this, _this$2);

  return false;
}.bind(undefined);

/**
 * Returns a new promise which follows the one given returning true in case
 * there was no error, or false otherwise
 */
var booleanize = function (promise) {
  _newArrowCheck(this, _this$2);

  return promise.then(returnTrue).catch(returnFalse);
}.bind(undefined);

var _this$3 = undefined;

/**
 * Chains all promises starting from initialPromise and binding chainers to
 * next methods 
 */
var chain = function (chainers, initialPromise) {
  _newArrowCheck(this, _this$3);

  return chainers.reduce(function (lastPromise, chainNext) {
    _newArrowCheck(this, _this$3);

    return lastPromise.then(chainNext);
  }.bind(this), initialPromise);
}.bind(undefined);

var chain$1 = curry(chain);

var _this$4 = undefined;

/**
 * Creates a Deferred
 */
var createDeferred = function () {
  _newArrowCheck(this, _this$4);

  var deferred = {};

  deferred.promise = new _Promise(function (resolve, reject) {
    _newArrowCheck(this, _this$4);

    return _Object$assign(deferred, { resolve: resolve, reject: reject });
  }.bind(this));

  // we are casting to any as otherwise flow thinks
  // deferred has neither resolve, nor reject methods
  return deferred;
}.bind(undefined);

var _this$5 = undefined;

var getPromiseSettler = function (resolve, reject) {
  _newArrowCheck(this, _this$5);

  return function (error, result) {
    _newArrowCheck(this, _this$5);

    if (error) {
      reject(error);
    } else {
      resolve(result);
    }
  }.bind(this);
}.bind(undefined);

var getLastArg = function (fn, args) {
  _newArrowCheck(this, _this$5);

  return args[fn.length - 1];
}.bind(undefined);

/**
 * Returns a new function that:
 * - if last argument is a callback =>
 *   it will mimic the function given.
 * - if last argument is not a callback =>
 *   it will return a promise which will be resolved or rejected following the
 *   execution of the function given.
 */
var promisifyFunction = function (fn) {
  _newArrowCheck(this, _this$5);

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _newArrowCheck(this, _this$5);

    return typeof getLastArg(fn, args) === "function" ? fn.apply(undefined, _toConsumableArray(args)) : new _Promise(function (resolve, reject) {
      _newArrowCheck(this, _this$5);

      return fn.apply(undefined, _toConsumableArray(args.concat(getPromiseSettler(resolve, reject))));
    }.bind(this));
  }.bind(this);
}.bind(undefined);

var _this$6 = undefined;

// TODO: retrieve map from @jumpn/utils-object once we have this one
var promisifyIfMethod = function (value, key, object) {
  _newArrowCheck(this, _this$6);

  return typeof value === "function" ? promisifyFunction(object[value].bind(object)) : value;
}.bind(undefined);

/**
 * Returns a new object with the result of having promisified all the methods of
 * the one given.
 */
var promisifyObject = function (object) {
  _newArrowCheck(this, _this$6);

  return map(promisifyIfMethod, object);
}.bind(undefined);

var _this$7 = undefined;

var createInfo = function (status, result) {
  _newArrowCheck(this, _this$7);

  return {
    status: status,
    result: result
  };
}.bind(undefined);

var get = function (promise) {
  _newArrowCheck(this, _this$7);

  return new _Promise(function (resolve) {
    _newArrowCheck(this, _this$7);

    var handler = function (status) {
      _newArrowCheck(this, _this$7);

      return function (result) {
        _newArrowCheck(this, _this$7);

        return resolve(createInfo(status, result));
      }.bind(this);
    }.bind(this);

    promise.then(handler("resolved")).catch(handler("rejected"));
  }.bind(this));
}.bind(undefined);

/**
 * Returns an object with status and value properties that are updated as soon
 * as the promise is resolved or rejected
 */
var track = function (promise) {
  _newArrowCheck(this, _this$7);

  var info = createInfo();

  get(promise).then(function (updatedInfo) {
    _newArrowCheck(this, _this$7);

    return _Object$assign(info, updatedInfo);
  }.bind(this));

  return info;
}.bind(undefined);

var _this$8 = undefined;

/**
 * Returns a promise that will be resolved with the result of execute,
 * or rejected with the error thrown by it (if any).
 */
var promiseTry = function (execute) {
  _newArrowCheck(this, _this$8);

  return new _Promise(function (resolve) {
    _newArrowCheck(this, _this$8);

    return resolve(execute());
  }.bind(this));
}.bind(undefined);

export { allByName, booleanize, chain$1 as chain, createDeferred, promisifyFunction, promisifyObject, track, promiseTry as try };
